import React from "react"

import styles from "./section.module.scss"

const Section = props => {
  return (
    <section
      className={styles.section}
      data-theme={props.theme ? props.theme : "primary"}
      data-bg={props.bg ? props.bg : "white"}
    >
      {props.sectionTitle && (
        <h2 className={styles.sectionTitle}>{props.sectionTitle}</h2>
      )}
      {props.children}
    </section>
  )
}

export default Section
